import { type PropsWithChildren } from 'react'
import { type ResponsiveStyleValue } from '@dhl-ui/theme'
import { type BaseProps } from '../../types'
import { type StackSxProps } from './types'
import { Stack } from './Stack'

type Props = PropsWithChildren<{
  /**
   * Space between the elements
   * @default 1
   */
  gap?: number | ResponsiveStyleValue<string | number>
}> &
  BaseProps<HTMLDivElement, never, StackSxProps>

/**
 * StackRow
 *
 * Demos:
 * - [StackRow](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/story/primitives-stack--abstraction-stack-row)
 *
 */

export const StackRow = ({ children, gap = 1, sx, ...rest }: Props) => (
  <Stack
    direction="row"
    {...rest}
    sx={{
      gap,
      alignItems: 'center',
      width: '100%',
      ...sx,
    }}
  >
    {children}
  </Stack>
)
